import React from 'react';
import { Facebook, Instagram, Mail, Heart } from 'lucide-react';

export const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#8B7355] text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-honey-400 to-honey-600 rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-lg">B</span>
              </div>
              <div>
                <h3 className="text-xl font-bold text-white">Burbujas de mami</h3>
                <p className="text-xs text-white/80">100% Natural</p>
              </div>
            </div>
            <p className="text-white/90 text-sm leading-relaxed">
              Productos capilares artesanales elaborados con miel de abeja orgánica. 
              Sin parabenos, sin sulfatos.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-4 text-white">Enlaces rápidos</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('productos')}
                  className="text-white/90 hover:text-white transition-colors text-sm"
                >
                  Productos
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('sobre-nosotros')}
                  className="text-white/90 hover:text-white transition-colors text-sm"
                >
                  Sobre nosotros
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('faq')}
                  className="text-white/90 hover:text-white transition-colors text-sm"
                >
                  FAQ
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contacto')}
                  className="text-white/90 hover:text-white transition-colors text-sm"
                >
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="font-bold text-lg mb-4 text-white">Productos</h4>
            <p className="text-white/90 text-sm">Guadalajara, Jalisco, México</p>
          </div>

          {/* Contact & Social */}
          <div>
            <h4 className="font-bold text-lg mb-4 text-white">Síguenos</h4>
            <div className="flex space-x-4 mb-4">
              <a
                href="https://www.instagram.com/burbujas_de_mami/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5 text-white" />
              </a>
              <a
                href="mailto:contacto@burbujasdemami.com"
                className="w-10 h-10 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center transition-colors"
                aria-label="Email"
              >
                <Mail className="w-5 h-5 text-white" />
              </a>
            </div>
            <p className="text-white/90 text-sm mb-2">
              burbujasdemami1@gmail.com
            </p>
            <p className="text-white/90 text-sm mb-2">
              @burbujas_de_mami
            </p>
            <a href="https://wa.me/523347591562" target="_blank" rel="noopener noreferrer" className="text-white/90 text-sm hover:text-white">
              WhatsApp: 33 4759 1562
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-white/80 text-sm">
              © 2024 Burbujas de mami. Todos los derechos reservados.
            </p>
            <p className="text-white/80 text-sm flex items-center">
              Hecho con <Heart className="w-4 h-4 mx-1 text-rose-400 fill-rose-400" /> en México
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
